require('./billingInfoController');
require('../results/results');
require("../../shared/selectWithDisabledOption/selectWithDisabledOptionDirective");

"use strict";

angular.module('app.purchase.billingInfo', [
    'app.purchase.billingInfo.billingInfoController',
    'app.purchase.results'
])
    .config([
        '$stateProvider',
        function ($stateProvider) {
            $stateProvider.state('app.purchase.billingInfo', {
                url: '/purchase/billing_info',
                templateUrl: 'components/purchase/billingInfo/billingInfoView.html',
                controller: 'app.purchase.billingInfo.billingInfoController',
                params: {
                    plan: null,
                    team: null,
                    upgrade: false,
                    uuid: null
                },
                title: 'Billing Information'
            })
        }
    ]);


// WEBPACK FOOTER //
// ./app.v2/components/purchase/billingInfo/billingInfo.js